export default {
  namespaced: true,
  state: {
    StoreVendorsMap: {
      activeVendor: {
        id: undefined,
      },
    },
  },
  getters: {
    activeVendor(state) {
      return state.StoreVendorsMap.activeVendor;
    },
  },
  actions: {
    setActiveVendor: (context, data) => {
      context.commit("setActiveVendor", data);
    },
  },
  mutations: {
    setActiveVendor: (state, vendor) => {
      state.StoreVendorsMap.activeVendor = vendor;
    },
  },
};
